module.exports = __webpack_public_path__ + "static/media/IMG_1352.65bf3483.jpg";